// Оператор туров каталога (ГОР-КИ, Кисловодск): контакты для кнопок «Позвонить / WhatsApp / Telegram» на страницах клиента.
// Контакты меняет админ в кабинете («Контакты для клиентов»): они приходят из публичного GET /api/company
// при запуске приложения и сразу подменяют значения ниже. Значения из frontend/.env.production (подстановка Vite
// на этапе сборки; в dev-режиме — frontend/.env.development) показываются, пока ответ API не пришёл или если API недоступен.
import { reactive } from "vue";
import axios from "axios";
import { resolveApiBaseUrl } from "@/config/apiBaseUrl";

export const COMPANY = reactive({
  name: "ГОР-КИ",
  experience: "15+ лет в горах",
  // Из .env: контакты для кнопок «WhatsApp / Telegram / телефон»
  phone: import.meta.env.VITE_COMPANY_PHONE,
  tel: import.meta.env.VITE_COMPANY_TEL,
  whatsapp: import.meta.env.VITE_COMPANY_WHATSAPP,
  telegram: import.meta.env.VITE_COMPANY_TELEGRAM,
  email: "aus26@yandex.ru",
  // Из .env: адрес офиса, подпись ссылки на отзывы, фотограф и подпись к его фото
  address: import.meta.env.VITE_COMPANY_ADDRESS,
  reviews: "https://yandex.ru/maps/org/gor_ki_ru/120391614475/",
  reviewsLabel: import.meta.env.VITE_COMPANY_REVIEWS_LABEL,
  photographer: import.meta.env.VITE_COMPANY_PHOTOGRAPHER,
  photoCreditLabel: import.meta.env.VITE_COMPANY_PHOTO_CREDIT_LABEL,
  groupSize: 7,
});

// Поля ответа GET /api/company, которые заменяют значения по умолчанию (подписи из .env остаются)
const FROM_API = ["name", "experience", "phone", "tel", "whatsapp", "telegram", "email", "address", "reviews", "photographer", "groupSize"];

/** Подставить контакты из ответа API (пустые значения не затирают значения по умолчанию). */
export const applyCompany = (data = {}) => {
  for (const key of FROM_API) {
    if (data[key] !== undefined && data[key] !== null && data[key] !== "") COMPANY[key] = data[key];
  }
};

let loading = null;
/** Загрузить контакты один раз. Обычный axios: запрос публичный и не должен уводить гостя на страницу входа. */
export const loadCompany = (force = false) => {
  if (!loading || force) {
    loading = axios.get(`${resolveApiBaseUrl()}/company`).then(({ data }) => applyCompany(data)).catch(() => {});
  }

  return loading;
};

/** Ссылка на WhatsApp с готовым текстом. */
export const whatsappLink = (text) => `${COMPANY.whatsapp}?text=${encodeURIComponent(text)}`;
